module.exports = __webpack_public_path__ + "static/Img-d1a8da982a03d3c77ff81d861566b4d3.png";